/* Keep article navigation reliable with the theme's sticky header and rich-text layout. */
(() => {
  const guide = document.querySelector('.starlink-setup-guide');
  if (!guide) return;
  const reveal = hash => {
    const section = document.getElementById(hash.slice(1));
    if (!section || !guide.contains(section)) return false;
    section.scrollIntoView({ block: 'start', behavior: 'instant' });
    section.setAttribute('tabindex', '-1');
    section.focus({ preventScroll: true });
    return true;
  };
  guide.addEventListener('click', event => {
    const link = event.target.closest('.starlink-setup-toc a[href^="#"]');
    if (!link || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
    if (reveal(link.hash)) {
      event.preventDefault();
      history.replaceState(null, '', link.hash);
    }
  });
  if (location.hash) {
    if (document.readyState === 'complete') reveal(location.hash);
    else window.addEventListener('load', () => reveal(location.hash), { once: true });
  }
})();
